module.exports = __webpack_public_path__ + "img/ski_cos3.770b7f69.png";